// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object, oneOfType, string } from 'prop-types'
import Row from './Row'

class TBody extends React.PureComponent {
  static propTypes = {
    columns: array.isRequired,
    customProps: object,
    data: array.isRequired,
    idRoot: string.isRequired,
    rowClass: oneOfType([
      func,
      string,
    ]),
    rowClick: func,
    TooltipTrigger: func.isRequired,
    unitType: string,
  }

  render () {
    const {
      columns,
      customProps,
      data,
      idRoot,
      rowClass,
      rowClick,
      TooltipTrigger,
      unitType,
    } = this.props

    return (
      <tbody className={'bg-white'}>
        {data.map((d, i) => (
          <Row
            key={`${idRoot}-${d[d.uniqueId]}`}
            columns={columns}
            customProps={customProps}
            idRoot={idRoot}
            rowClass={rowClass}
            rowClick={rowClick}
            rowData={d}
            rowIndex={i}
            TooltipTrigger={TooltipTrigger}
            unitType={unitType} />
        ))}
      </tbody>
    )
  }
}

export default TBody
